import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function NotFound() {
  return (
    <div className="page-wrapper">
      <Helmet>
        <title>Page Not Found | Clariti AI</title>
        <meta name="robots" content="noindex,follow" />
      </Helmet>
      <section className="resources-hero">
        <div className="container">
          <h1>Page not found</h1>
          <p>The page you are looking for does not exist.</p>
          <Link to="/" className="btn btn-primary" style={{ marginTop: '20px' }}>
            Back to Home
          </Link>
        </div>
      </section>
    </div>
  );
}

export default NotFound;
